import React, { useEffect, useState } from 'react';
import { MessageSquareHeart, Check } from 'lucide-react';
import { Button } from './ui/button';
import { api } from '../lib/api';
import { useLang } from '../context/LangContext';

export const WorkerNotes = () => {
  const { t } = useLang();
  const [msgs, setMsgs] = useState([]);
  useEffect(() => { api.get('/messages').then(({ data }) => setMsgs(data.messages.filter((m) => !m.read))).catch(() => {}); }, []);
  if (!msgs.length) return null;
  const ack = async (m) => { await api.post(`/messages/${m.message_id}/read`); setMsgs((c) => c.filter((x) => x.message_id !== m.message_id)); };
  return (
    <div className="mb-6 space-y-2" data-testid="worker-notes">
      {msgs.map((m) => (
        <div key={m.message_id} className="rounded-xl border border-[#B8D5E5] bg-[#EBF3FA] p-4 flex items-start gap-3" data-testid={`worker-note-${m.message_id}`} role="status">
          <MessageSquareHeart className="w-5 h-5 text-[#1E5888] shrink-0 mt-0.5" />
          <div className="flex-1">
            <div className="text-xs font-semibold text-[#13426B]">{t('Note from your worker')} · {m.from_name}{m.organization ? ` (${m.organization})` : ''} · {new Date(m.created_at).toLocaleDateString()}</div>
            <p className="text-sm text-[#13426B] mt-1">{m.text}</p>
          </div>
          <Button size="sm" variant="outline" className="bg-white" onClick={() => ack(m)} data-testid={`worker-note-ack-${m.message_id}`}><Check className="w-3.5 h-3.5 mr-1" /> {t('Got it')}</Button>
        </div>
      ))}
    </div>
  );
};
